<template>
  <v-card class="mx-auto" max-width="600" elevation="3">
    <v-toolbar flat dense>
      <v-toolbar-title>
        <span class="subtitle primary--text pr-3">{{sucClave}}</span>
        <span class="overline font-weight-light mr-1 pl-3">{{title}}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon @click="valida" color="primary lighten-1">fas fa-cart-plus</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text>
      <v-row class="mb-4" justify="space-between">
        <v-col class="text-left">
          <span class="display-3 font-weight-light">{{itemsQty}}</span>
          <span class="subheading font-weight-light mr-1 pl-3">Artículos</span>
        </v-col>
        <v-col class="text-right">
          <span class="display-3 font-weight-light">$1250.00</span>
          <span class="subheading font-weight-light mr-1 pl-3">pesos</span>
        </v-col>
      </v-row>
      <v-row no-gutters justify="space-between">
        <v-col class="text-center">
          <span class="overline font-weight-light">40%</span>
          <span class="overline font-weight-light mr-1 pl-3">Márgen</span>
        </v-col>
      </v-row>
      <v-row>
        <v-data-table
          class="caption"
          dense
          :headers="headers"
          :items="dataTable"
          disable-filtering
          disable-pagination
          disable-sort
          hide-default-footer
        ></v-data-table>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
  export default {
    props: ["sucClave", "title", "itemsQty"],
    data: () => ({
      headers: [
        {
          text: "Producto",
          value: "product.MATNR",
          align: "left"
        },

        {
          text: "Descripcion",
          value: "product.ZTX70",
          align: "left"
        }
      ]
    }),
    computed: {
      color() {
        return "red";
      },
      icono() {
        return "far fa-thumbs-up";
      },
      dataTable() {
        let self = this;
        _.forEach(this.$store.getters.getListaProductoDetalle, function(
          value,
          key
        ) {
          console.log("Recorriendo Foreache");
          console.log(key);
          console.log(value.existencia);
          //Buscando existencia del centro....
          let resultado = _.find(value.existencia, { sucClave: self.sucClave });
          console.log("Validando sucursal....");
          console.log(resultado);
          //REVISAR AQUI.....
          if (
            value.existencia.sucClave == self.sucClave &&
            value.existencia.qty > 0
          ) {
            console.log("Se añadira a ..." + self.sucClave);
            console.log(value);
          }
        });
        return this.$store.getters.getListaProductoDetalle;
      },
      ...mapGetters(["getActualCotizationPartidas"])
    },
    methods: {
      valida() {
        console.log(this.dataTable);
      }
    }
  };
</script>